<hr class="w-75 mx-auto mb-5">

<div class="container mt-5">
  <div class="container text-center">
    <img class="text-center" ngSrc="assets/img/ambulancia/portafolio.svg" width="50" height="50" alt="">
  </div>
  <p class="fs-2 text-center" style="color:var(--primary-color);">Servicios <span class="fw-bolder"> Empresariales</span></p>
</div>


<div class="container allEnterpriseServices my-5 ">

  <div class="row  justify-content-center g-5">
    <div class="col-md-5 d-flex   flex-column justify-content-center">
      <img class="my-1" ngSrc="assets/img/ambulancia/zonaProtegida.svg" width="50" alt="" height="50">
      <p class="fs-4 fw-normal lh-1 fw-bolder" style="color: var(--primary-color)">Zona Protegida</p>
      <p class="text-body-secondary fs-5 w-75">Para colaboradores que requieran asistencia médica y/o traslados en caso de urgencia y emergencia.</p>
    </div>
    <div class="col-md-5">
<!--      <img ngSrc="assets/img/agendar.png" alt=""  class="imagenRadius">-->
    </div>
  </div>


  <div class="row justify-content-center g-5">
    <div class="col-md-5  d-flex   flex-column justify-content-center order-md-2">
      <img class="my-1" ngSrc="assets/img/ambulancia/permanenciaAmbulancia.svg" width="50" alt="s" height="50">
      <p class="fs-4 fw-normal lh-1 fw-bolder" style="color: var(--primary-color)">Permanencia de Ambulancia</p>
      <p class="text-body-secondary fs-5 w-75">Permanencia dentro de las instalaciones de la empresa para asistencia médica y traslados para sus colaboradores.</p>
    </div>
    <div class="col-md-5 order-md-1">
<!--      <img ngSrc="assets/img/agendar.png" alt="" width="455" height="400" class="imagenRadius">-->
    </div>
  </div>

<!--  <hr class="-divider">-->

  <div class="row justify-content-center g-5">
    <div class="col-md-5 d-flex   flex-column justify-content-center">
      <img class="my-1" ngSrc="assets/img/ambulancia/coberturaEvento.svg" width="50" alt="" height="50">
      <p class="fs-4 fw-normal lh-1 fw-bolder" style="color: var(--primary-color)">Cobertura de Eventos</p>
      <p class="text-body-secondary fs-5 w-75">Asistencia médica en toda clase de eventos de pequeña o gran magnitud.</p>
    </div>
    <div class="col-md-5">
<!--      <img ngSrc="assets/img/agendar.png" alt="" width="455" height="400" class="imagenRadius" >-->
    </div>
  </div>

</div>

<hr class="mx-auto w-75">


<div class="container text-center mb-3 mt-2">
  <span style="color: var(--primary-color)" class="fs-4">Consulta por nuestros <br> <span class="fw-bolder"> servicios empresariales</span></span>
</div>

<div class="container-fluid text-center w-100  mt-1 mb-5">
  <a href="mailto:comercial@medilink.com.ec "  type="button" class="btn botonEmailAmbulancia  fs-2 mb-5"><i class="bi bi-envelope"></i> comercial&#64;medilink.com.ec</a>
</div>
